import { useEffect, useState } from "react";
import { IWatch } from "../watches/adminWatches";
import AdminModal from "../../../core/admin/adminModal";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useWatches } from "../../../../context/watchProvider";
import BuyerScoreCard from "../../../core/buyerScoreCard";
import { IBuyerScore } from "../../../../utils/buyerScore";
import AdminCard from "../../../core/admin/adminCard";
import AdminTable from "../../../core/admin/adminTable";
import AdminTabs from "../../../core/admin/adminTabs";
import AdminButton from "../../../core/admin/adminButton";
import AdminDetails from "../../../core/admin/adminDetails";
import AdminCallout from "../../../core/admin/adminCallout";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import AdminWatchSpecs from "../../../core/admin/adminWatchSpecs";
import AdminWatchGallery from "../../../core/admin/adminWatchGallery";
import { AdminCount } from "../../../core/admin/adminBadge";
import { AdminLoading } from "../../../core/admin/adminSpinner";

export default function SoldWatches({ watches }: { watches: IWatch[] }) {

    const { getBuyerScore } = useWatches();

    const [infosModal, setInfosModal] = useState(false);
    const [watch, setWatch] = useState<IWatch | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)
    const [buyerEmail, setBuyerEmail] = useState("");
    const [buyerScore, setBuyerScore] = useState<IBuyerScore | null>(null);
    const [buyerScoreLoading, setBuyerScoreLoading] = useState(false);

    // abas do modal (antes: sub-modais pretos de detalhes e de imagens)
    const [tab, setTab] = useState<"summary" | "details" | "images">("summary");

    useEffect(() => {
        if (infosModal) {
            getBuyer();
        }
        // eslint-disable-next-line
    }, [infosModal])

    const getBuyer = async () => {
        try {
            if (!watch) {
                return null;
            }
            setLoading(true);

            const docRef = doc(db, "users", watch.buyer);
            const docSnap = await getDoc(docRef);
            if (!docSnap.exists()) {
                setLoading(false);
                setError(true);
                return null;
            }
            const data = docSnap.data();
            if (!data) {
                setLoading(false);
                setError(true);
                return null;
            }
            setBuyerEmail(data.email);
            setLoading(false);
            setBuyerScoreLoading(true);
            const score = await getBuyerScore(watch.buyer);
            setBuyerScore(score);
            setBuyerScoreLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false);
            setError(true);
        }
    }

    const handleModal = (w: IWatch) => {
        setWatch(w);
        setTab("summary");
        setInfosModal(true);
        setBuyerEmail("");
        setBuyerScore(null);
    }

    const formatSoldAt = (w: IWatch | null) => w?.soldAt ? new Date(w.soldAt?.seconds * 1000)?.toLocaleDateString("pt-BR") : "";

    return (
        <AdminCard title={<>Vendidos <AdminCount count={watches.length} /></>} description="Vendas registradas por você." bodyClassName="p-3 md:p-4">
            {
                watches.length ?
                    <AdminTable
                        rows={watches}
                        rowKey={(w, idx) => w.id || idx}
                        columns={[
                            { header: "Relógio", mobile: "title", desktopHidden: true, render: w => `${w.brand || ""} ${w.model || ""}` },
                            { header: "Marca", mobile: "hidden", render: w => <span className="font-semibold">{w.brand}</span> },
                            { header: "Modelo", mobile: "hidden", render: w => w.model },
                            { header: "Ano", render: w => w.year },
                            { header: "Vendido em", className: "whitespace-nowrap", render: w => formatSoldAt(w) || "—" },
                        ]}
                        actions={w => <AdminButton size="sm" variant="secondary" onClick={() => handleModal(w)}>Ver</AdminButton>}
                    />
                    :
                    <AdminEmptyState title="Nenhum relógio listado" />
            }
            {
                infosModal ?
                    <AdminModal
                        close={() => setInfosModal(false)}
                        size="lg"
                        title={`${watch?.brand || ""} ${watch?.model || ""}`}
                        subtitle={`Ano ${watch?.year || "—"}${formatSoldAt(watch) ? ` · vendido em ${formatSoldAt(watch)}` : ""}`}
                        tabs={
                            <AdminTabs
                                value={tab}
                                onChange={setTab}
                                tabs={[
                                    { value: "summary", label: "Resumo" },
                                    { value: "details", label: "Detalhes" },
                                    { value: "images", label: "Imagens", count: watch?.images?.length || 0 },
                                ]}
                            />
                        }
                    >
                        {
                            tab === "summary" ?
                                <div className="flex flex-col gap-6">
                                    <AdminDetails
                                        items={[
                                            { label: "Serial", value: watch?.serial?.toUpperCase() },
                                            { label: "Marca", value: watch?.brand },
                                            { label: "Modelo", value: watch?.model },
                                            { label: "Ano", value: watch?.year },
                                        ]}
                                    />
                                    <section>
                                        <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-3">Comprador</h3>
                                        {
                                            loading ?
                                                <AdminLoading />
                                                : error ?
                                                    <AdminCallout tone="danger">Erro ao obter usuário comprador</AdminCallout>
                                                    :
                                                    <div className="flex flex-col gap-3">
                                                        <p className="rounded-lg bg-gray-50 px-4 py-3 text-sm font-semibold text-gray-900 ring-1 ring-gray-200 break-all">{buyerEmail}</p>
                                                        <BuyerScoreCard buyerScore={buyerScore} loading={buyerScoreLoading} variant="compact" />
                                                    </div>
                                        }
                                    </section>
                                </div>
                                : tab === "details" && watch ?
                                    <AdminWatchSpecs watch={watch} />
                                    : tab === "images" ?
                                        <AdminWatchGallery images={watch?.images} />
                                        : null
                        }
                    </AdminModal>
                    : null
            }
        </AdminCard>
    )
}
